const readVersionKey = 'read-version-whats-new';

export const getReadVersion = () => localStorage.getItem(readVersionKey) || 0;

export const setReadVersion = value => localStorage.setItem(readVersionKey, value);
